const WISE_DOMAINS = new Set(['wise.com', 'dev-wi.se', 'transferwise.com', 'trwi.se']);

function createUrl(path) {
  if (typeof window !== 'undefined') {
    const { hostname } = window.location;
    if (WISE_DOMAINS.has(hostname) || /customenvs.k8stw.com/g.test(hostname)) {
      return `https://${hostname}${path}`;
    }
  }
  return `https://wise.com${path}`;
}

export default createUrl;
